import Upload from './upload.vue'
import LockUpload from './lock-upload.vue'
import FlexBox from './flex-box.vue'
import Drawer from './drawer'
import Affix from './affix.vue'

const components = {
	Upload,
	LockUpload,
	FlexBox,
    Drawer,
    Affix
}

function install(Vue) {
	Object.keys(components).forEach(key => {
		Vue.component(`u${key}`, components[key])
	})
}

export {
	Upload,
	LockUpload,
	FlexBox,
    Drawer,
    Affix
}

export default install
